module.exports = __webpack_public_path__ + "img/celine-accor-hotels-arena.199fd351.jpg";